// extracted by mini-css-extract-plugin
export default {"investorproBtn":"styles_investorproBtn__HrVEl","investorproLink":"styles_investorproLink__-+zHw"};